
(function () {
  'use strict';
  angular.module('vcfinance.unicat')
    .component('unicatsearch', {
      restrict: 'E',
      bindings: {
      unicat: '<',
  unicatref: '<',
    parentsave: '&?',
    editinplace: '@?',
    ti: '@?'
},
  template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   autofocus
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showunicat($item, $model, $label)"
                   uib-typeahead="unicat as unicat.text for unicat in vm.getUnicats($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addUnicat()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addUnicat()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <unicateditor unicat="vm.unicat"></unicateditor>
        </div>
        
        
      `,
    controllerAs: 'vm',
    controller: ['$log', 'Unicat', 'UnicatHelper',
    function ($log, Unicat, UnicatHelper) {
    let vm = this;
    vm.save = save;
    vm.showunicat = showunicat;
    
    vm.getUnicats = getUnicats;
    // vm.addUnicat = UnicatHelper.addUnicat;
    vm.addUnicat = addUnicat;
    vm.editUnicat = UnicatHelper.editUnicat;
    
    vm.$onInit = function () {
      vm.newunicat = {};
      
      if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
        vm.editinplace = true;
      }
      
      $log.debug('debug - editinplace', vm.editinplace);
      
      
      if (angular.isUndefined(vm.ti))  {
        vm.ti = 0;
        vm.tabi = 0;
      }
      if (angular.isString(vm.ti)) {
        vm.tabi = parseInt(vm.ti, 10);
      }
      else {
        vm.tabi = 0;
      }
      vm.lastunicat = angular.copy(vm.unicatresult);
      vm.lastunicatref = angular.copy(vm.unicatref);
    };
    
    function addUnicat() {
      $log.debug('debug - unicatsearch addUnicat called');
    UnicatHelper.addUnicat(function (unicat) {
        $log.debug('debug: handle newly create unicat');
        vm.unicat = {};
        vm.unicat.name = unicat.name;
        vm.unicat.short = unicat.short;
        vm.unicat._id = unicat._id;
        vm.unicatref = unicat._id;
        vm.asyncSelected = unicat.short;
        vm.parentsave({unicat: vm.unicat, unicatref: vm.unicatref});
      }, function (err) {
        vm.error = true;
        $log.error(err);
      });
    }
    
    
    // typeahead unicat search backend query
    function getUnicats(val) {
      // return Unicatahead.$search({query: val}).$asPromise().then(function (response) {
      return Unicat.$searchahead({query: val}).$asPromise().then(function (response) {
        return response.map(function (unicat) {
        unicat.text = unicat.short;
          delete vm.error;
          return unicat;
        });
      });
    }
    
    // typeahead unicat search action
    function showunicat($item, $model, $label) {
      /* jshint unused:false */
      /* eslint "no-unused-lets": [2, {"args": "none"}] */
      vm.unicat = $model;
      vm.unicatref = $model._id;
      delete vm.asyncSelected;
      vm.editinplace = true;
      $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
      if (vm.editinplace === true) {
        vm.unicat = $model;
        vm.unicatref = $model._id;
        $log.debug('debug - unicatsearch editinplace');
      }
      else {
        vm.unicat = {};
        vm.unicat.name = $model.name;
        vm.unicat.short = $model.short;
        vm.unicat._id = $model._id;
        vm.unicatref = $model._id;
        vm.parentsave({unicat: vm.unicat, unicatref: vm.unicatref});
        $log.debug('debug - unicatsearch do not  editinplace', vm.parentsave);
      }
    }
    
    function save() {
      if (!angular.equals(vm.unicat, vm.lastunicat) || !angular.equals(vm.unicatref, vm.lastunicatref) ) {
        vm.lastunicat = angular.copy(vm.unicat);
        vm.lastunicatref = angular.copy(vm.unicatref);
        vm.parentsave({unicat: vm.unicat, unicatref: vm.unicatref});
      }
    }
    
    
  }] // controller
}); // component

// klammerfriedhof
}());